import React, { useMemo } from "react";
import { StylePackColorPalette } from "../../utils/content-templates";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { GreenroomState } from "../../stores/types/types";
import { Theme } from "../../stores/types/themes";

const ColorPalettesContainer = styled.div`
    display: inline-grid;
    grid-template-columns: auto auto auto;
    column-gap: 24px;
    row-gap: 16px;
    width: 100%;
    margin-bottom: 16px;
`;

const ColorSwatch = styled.div`
    display: flex;
    margin-top: 8px;
`;

const Color = styled.div`
    width: 24px;
    height: 24px;
    border-radius: 4px;
    border: 0.5px solid rgba(255, 255, 255, 0.20);
    margin-right: 4px;
`;

export interface StylePacksColorPalettesProps {
    stylepack: string;
}

export default function StylePackColorPalettes(props: StylePacksColorPalettesProps) {
    const { stylepack } = props;
    const defaultThemes = useSelector((s:GreenroomState) => s.ThemesReducer.defaultThemes);

    // first 3 colors of first 3 themes
    const colorPalettes = useMemo(
        () => defaultThemes.filter((t:Theme) => t.stylepack === stylepack).map(
            (t) => ({...t, colors: t.colors.slice(0, 3)})).slice(0, 3), 
    [defaultThemes, stylepack])

    return (
        <ColorPalettesContainer>
            {colorPalettes.map((palette) => (
                <div className="bl-font-s1">
                    {palette.name}
                    <ColorSwatch>
                        {palette.colors.map((color) => (
                            <Color style={{ backgroundColor: color }} key={color}/>
                        ))}
                    </ColorSwatch>
                </div>
            ))}
        </ColorPalettesContainer>
    );
}
